import { render } from "./BotLogTab.vue?vue&type=template&id=e2801166&scoped=true"
import script from "./BotLogTab.vue?vue&type=script&lang=js"
export * from "./BotLogTab.vue?vue&type=script&lang=js"

import "./BotLogTab.vue?vue&type=style&index=0&id=e2801166&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2801166"]])

export default __exports__